@if (toasts && toasts.length > 0) {
  <div >
    @for (toast of toasts; track toast; let index = $index) {
      <div>
        <div class="toast-container alert" [ngClass]="{'alert-primary': toast.level === 0, 'alert-success': toast.level === 1, 'alert-warning': toast.level === 2, 'alert-danger': toast.level === 3}" role="alert" (click)="remove(toast)">
          <strong>{{toast.text}}</strong>
        </div>
      </div>
    }
  </div>
}